import { StudentDashboard } from './StudentDashboard';

export const DashboardRoute = () => {
  // TODO: switch dashboard based on user role
  return <StudentDashboard />;
};
